import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useDpStore = create(
  persist(
    (set) => ({

      successModalOpen: false,
      setSuccessModalOpen: (payload) =>
        set((state) => ({ successModalOpen: payload })),

      showTempButton: false,
      setShowTempButton: (payload) =>
        set((state) => ({ showTempButton: payload })),

      isEnquiryModalOpen: false,
      setIsEnquiryModalOpen: (payload) =>
        set((state) => ({ isEnquiryModalOpen: payload })),

      isLoactionModalOpen: false,
      setIsLoactionModalOpen: (payload) =>
        set((state) => ({ isLoactionModalOpen: payload })),

      isMapModalOpen: false,
      setIsMapModalOpen: (payload) =>
        set((state) => ({ isMapModalOpen: payload })),

      enquiryFormData: {
        whatsappNumber: "",
        whatsappNumberError: false,
        fullName: "",
        fullNameError: false,
        siteLocation: "",
        siteLocationError: false,
        // Structured address parts (city/state/pincode/lat/lng) captured
        // alongside the formatted siteLocation string, for the v2 lead-gen
        // API's structured address object. See MapModal/Geocoder.
        siteLocationDetails: null,
      },
      setEnquiryFormData: (payload) =>
        set((state) => ({ enquiryFormData: payload })),

      siteLoactionMode: "google", //map or manual or search
      setSiteLoactionMode: (payload) =>
        set((state) => ({ siteLoactionMode: payload })),

      searchQuery: "",
      setSearchQuery: (payload) => set((state) => ({ searchQuery: payload })),
    }),
    {
      name: "dp-store", // unique name for localStorage key
    }
  )
);

export const useSelectedTag = create((set) => ({
  selectedTag: "All",
  setSelectedTag: (payload) => set((state) => ({ selectedTag: payload })),
}));
